import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

function Timeline({ education }) {
  const { years, title, content1, content2, content3, content4, content5, content6, content7, content8 } = education;
  return (
    <ScrollAnimation
      animateIn="fadeInUp"
      animateOut="fadeInOut"
      animateOnce={true}
    >
      <div className="timeline-container">
        <div className="content">
          <span className="time">{years}</span>
          <h3 className="title">{title}</h3>
          {content1 && content1.description1 ? <p><h4>{content1.title}</h4> {content1.description1} {content1.description2 && <p>{content1.description2}</p>}</p> : <p>{content1}</p>}
          {content2 && content2.description1 ? <p><h4>{content2.title}</h4> {content2.description1} {content2.description2 && <p>{content2.description2}</p>}</p> : <p>{content2}</p>}
          {content3 && content3.description1 ? <p><h4>{content3.title}</h4> {content3.description1} {content3.description2 && <p>{content3.description2}</p>}</p> : <p>{content3}</p>}
          {content4 && content4.description1 ? <p><h4>{content4.title}</h4> {content4.description1} {content4.description2 && <p>{content4.description2}</p>}</p> : <p>{content4}</p>}
          {content5 && content5.description1 ? <p><h4>{content5.title}</h4> {content5.description1} {content5.description2 && <p>{content5.description2}</p>}</p> : <p>{content5}</p>}
          {content6 && content6.description1 ? <p><h4>{content6.title}</h4> {content6.description1} {content6.description2 && <p>{content6.description2}</p>}</p> : <p>{content6}</p>}
          {content7 && content7.description1 ? <p><h4>{content7.title}</h4> {content7.description1} {content7.description2 && <p>{content7.description2}</p>}</p> : <p>{content7}</p>}
          {content8 && content8.description1 ? <p><h4>{content8.title}</h4> {content8.description1} {content8.description2 && <p>{content8.description2}</p>}</p> : <p>{content8}</p>}
        </div>
      </div>
    </ScrollAnimation>
  );
}

export default Timeline;
